/**
 * One work-reference grammar across every face and service.
 *
 * Legacy rows remain valid:
 * - J######### — platform Jobs
 * - T######### — isolated test Jobs
 * - O-######## — the five Opportunities created before the unified scheme
 *
 * New Pipeline work is P-MMYY-NNNNN. Winning it preserves the numeric identity
 * while changing the lifecycle prefix to J-MMYY-NNNNN.
 */
export const JOB_REF_PATTERN = /^(?:[JT]\d{9}|O-\d{8}|[PJ]-\d{4}-\d{5})$/;
export const LIVE_JOB_REF_PATTERN = /^(?:J\d{9}|O-\d{8}|[PJ]-\d{4}-\d{5})$/;
export const OPPORTUNITY_REF_PATTERN = /^(?:O-\d{8}|P-\d{4}-\d{5})$/;
export const WON_JOB_REF_PATTERN = /^(?:[JT]\d{9}|J-\d{4}-\d{5})$/;
export const isJobRef = (value) => typeof value === "string" && JOB_REF_PATTERN.test(value);
export const isLiveJobRef = (value) => typeof value === "string" && LIVE_JOB_REF_PATTERN.test(value);
export const isOpportunityRef = (value) => typeof value === "string" && OPPORTUNITY_REF_PATTERN.test(value);
export const isWonJobRef = (value) => typeof value === "string" && WON_JOB_REF_PATTERN.test(value);
//# sourceMappingURL=job-ref.js.map